<template>
  <!-- 目录 -->
  <el-menu
    :default-active="activeIndex"
    @select="handleSelect"
    @open="menuOpenHandle"
    @close="menuCloseHandle"
    class="el-menu-vertical-demo"
    background-color="#fff"
    text-color="#333333"
    active-text-color="#0FC29A"
  >
    <template v-for="menu in content">
      <el-submenu
        :key="menu.key"
        v-if="menu.children && menu.children.length > 0"
        :index="menu.key"
        :disabled="menu.isLock"
        :class="menu.isLock ? 'menu-lock' : ''"
      >
        <template slot="title">
          <span>{{ menu.name }}</span>
        </template>
        <subItem :content="menu.children" @getSubItem="onMenuItemClick"></subItem>
        <!-- <el-menu-item
          v-for="item in menu.children"
          :key="item.key"
          :index="item.key"
        >{{ item.name }}</el-menu-item> -->
      </el-submenu>
      <el-menu-item
        :key="menu.key"
        v-else
        :index="menu.key"
        :disabled="menu.isLock"
        :class="menu.isLock ? 'menu-lock' : ''"
      >{{ menu.name }}</el-menu-item>
    </template>
    

    <!-- <el-menu-item index="front">
      <span slot="title">文旌 · 数字教材</span>
    </el-menu-item>

    <el-menu-item index="section1">引子</el-menu-item>
    <el-menu-item index="section2">第1章 文旌课堂简介</el-menu-item>

    <el-submenu index="section3">
      <template slot="title">
        <span>第2章 文旌数字教材</span>
      </template>
      <el-menu-item index="section3.1">2.1 数字教材概述</el-menu-item>
      <el-menu-item index="section3.2">2.2 文旌数字教材功能介绍</el-menu-item>
    </el-submenu> -->

    
    <!-- <el-submenu index="section2">
      <template slot="title">
        <span>项目1 搭建机器学习开发环境</span>
      </template>
      <el-menu-item index="section2-1">项目目标</el-menu-item>
      <el-menu-item index="section2-2">项目描述</el-menu-item>
      <el-menu-item index="section2-3">项目分析</el-menu-item>
      <el-menu-item index="section2-4">项目准备</el-menu-item>
      <el-submenu index="section2-5">
        <template slot="title">
          <span>1.1 机器学习的概念与应用领域</span>
        </template>
        <el-submenu index="section2-5-1">
          <template slot="title"><span>1.1.1 机器学习的概念</span></template>
          <el-menu-item index="section2-5-1-1">1．什么是机器学习</el-menu-item>
          <el-menu-item index="section2-5-1-2">2．机器学习的相关术语</el-menu-item>
        </el-submenu>
        <el-submenu index="section2-5-2">
          <template slot="title"><span>1.1.2  机器学习的应用领域</span></template>
          <el-menu-item index="section2-5-2-3">1．语音识别</el-menu-item>
          <el-menu-item index="section2-5-2-4">2．计算机视觉</el-menu-item>
          <el-menu-item index="section2-5-2-5">3．自然语言处理</el-menu-item>
          <el-menu-item index="section2-5-2-6">4．自动驾驶</el-menu-item>
          <el-menu-item index="section2-5-2-7">5．大数据分析</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-submenu index="section2-6">
        <template slot="title">
          <span>1.2  机器学习的类型</span>
        </template>
        <el-submenu index="section2-6-1">
          <template slot="title"><span>1.2.1  按学习的过程分类</span></template>
          <el-menu-item index="section2-6-1-3">1．监督学习</el-menu-item>
          <el-menu-item index="section2-6-1-4">2．无监督学习</el-menu-item>
          <el-menu-item index="section2-6-1-5">3．半监督学习</el-menu-item>
          <el-menu-item index="section2-6-1-6">4．强化学习</el-menu-item>
          <el-menu-item index="section2-6-1-7">5．深度学习</el-menu-item>
        </el-submenu>
        <el-submenu index="section2-6-2">
          <template slot="title"><span>1.2.2  按完成的任务分类</span></template>
          <el-menu-item index="section2-6-2-2">1．回归</el-menu-item>
          <el-menu-item index="section2-6-2-3">2．分类</el-menu-item>
          <el-menu-item index="section2-6-2-4">3．聚类</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-submenu index="section2-7">
        <template slot="title">
          <span>1.3  机器学习的一般过程</span>
        </template>
        <el-menu-item index="section2-7-5">1.3.1  数据获取</el-menu-item>
        <el-menu-item index="section2-7-6">1.3.2  特征提取</el-menu-item>
        <el-submenu index="section2-7-7">
          <template slot="title"><span>1.3.3  数据预处理</span></template>
          <el-menu-item index="section2-7-7-7">1．去除唯一属性</el-menu-item>
          <el-menu-item index="section2-7-7-8">2．缺失值、重复值和异常值处理</el-menu-item>
          <el-menu-item index="section2-7-7-9">3．数据定量化</el-menu-item>
        </el-submenu>
        <el-menu-item index="section2-7-8">1.3.4  数据标准化</el-menu-item>
        <el-menu-item index="section2-7-9">1.3.5  数据降维</el-menu-item>
        <el-submenu index="section2-7-10">
          <template slot="title"><span>1.3.6  训练模型</span></template>
          <el-menu-item index="section2-7-10-1">1．训练集、验证集和测试集</el-menu-item>
          <el-menu-item index="section2-7-10-2">2．机器学习算法</el-menu-item>
        </el-submenu>
        <el-submenu index="section2-7-11">
          <template slot="title"><span>1.3.7  评估模型的有效性</span></template>
          <el-menu-item index="section2-7-11-2">1．过拟合与欠拟合</el-menu-item>
          <el-menu-item index="section2-7-11-3">2．性能度量</el-menu-item>
        </el-submenu>
        <el-menu-item index="section2-7-12">1.3.8  使用模型</el-menu-item>
      </el-submenu>
      <el-submenu index="section2-8">
        <template slot="title">
          <span>1.4  Python机器学习常用库</span>
        </template>
        <el-menu-item index="section2-8-1">1.4.1  NumPy——科学计算基础库</el-menu-item>
        <el-menu-item index="section2-8-2">1.4.2  SciPy——科学计算扩展库</el-menu-item>
        <el-menu-item index="section2-8-3">1.4.3  Pandas——数据分析工具库</el-menu-item>
        <el-menu-item index="section2-8-4">1.4.4  Matplotlib——数据可视化扩展库</el-menu-item>
        <el-menu-item index="section2-8-5">1.4.5  Scikit-learn——机器学习库</el-menu-item>
      </el-submenu>
      <el-menu-item index="section2-9">项目考核</el-menu-item>
    </el-submenu> -->
  </el-menu>
</template>
<script>
  import subItem from './subItem.vue';
  export default {
    name: "NavBar",
    components: {
      subItem,
    },
    props: {
      content: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        activeIndex: "front"
      }
    },
    methods: {
      onMenuItemClick(item) {
        console.log(item)
      },
      handleSelect(index) {
        this.$emit('chapterChange', index);
      },
      changeActiveIndex(activeIndex) {
        if(this.activeIndex === activeIndex) return;
        this.activeIndex = activeIndex;
      },


      menuOpenHandle(index) {
        // this.handleSelect(index)
      },
      menuCloseHandle(index) {
        // this.handleSelect(index)
      },
      // 导航滚动定位
      // handleSelect(index) {
      //   // 假设index的格式是'1-1'这样的，代表一级菜单下的某个子菜单
      //   this.$emit('custom-event');
      //   this.scrollToElement(index);
      // },
      // scrollToElement(index) {
      //   const element = document.getElementById(`${index}`);
      //   if (element) {
      //     element.scrollIntoView({behavior: 'smooth'}); // 平滑滚动
      //   }
      // },
    }
  }
</script>

<style lang="scss" scoped>
/deep/.el-submenu.menu-lock.is-disabled{
  position: relative;

  .el-submenu__title{
    padding-right: 55px;
    opacity: 1;
  }

  &:after{
    content: '';
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    right: 40px;
    background: url("~@/assets/images/common/lock.png") center center no-repeat;
    background-size: contain;
    cursor: not-allowed;
  }
}
/deep/.el-menu-item.menu-lock.is-disabled{
  position: relative;

  &:after{
    content: '';
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    right: 20px;
    background: url("~@/assets/images/common/lock.png") center center no-repeat;
    background-size: contain;
    cursor: not-allowed;
  }
}
/deep/.el-menu-item:hover{
  background-color: #f7f7f7 !important;
}
/deep/.el-menu-item:focus{
  background-color: #fff !important;
}
/deep/.el-submenu__title:hover{
  background-color: #f7f7f7 !important;
}
/deep/.el-menu-item,/deep/.el-submenu__title{
  font-size: 16px;
  line-height: 48px;
  height: 48px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-submenu .el-menu-item{
  font-size: 16px;
  line-height: 48px;
  height: 48px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
